"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Response = _interopRequireDefault(require("../factories/Response.js"));
var _api = require("../helpers/api.js");
var _dateTime = require("../helpers/dateTime.js");
var _response = require("../helpers/response.js");
var _constants = require("../constants");
var _createAction = require("../helpers/createAction.js");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var Responses = /*#__PURE__*/_createClass(function Responses(api) {
  var _this = this;
  _classCallCheck(this, Responses);
  this.responseSyncKey = function (quizId, questionId) {
    return "quizzes/".concat(quizId, "/responses/").concat(questionId);
  };
  this.responseEvaluateKey = function (quizId, questionId) {
    return "quizzes/".concat(quizId, "/responses/").concat(questionId, "/evaluate");
  };
  this.responseSet = function (quizId, questionId, selectedAnswer, hotspotIsCorrect) {
    var offline = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return function (dispatch, getState) {
      var _getState = getState(),
        questions = _getState.questions,
        loading = _getState.loading,
        responses = _getState.responses,
        quizzes = _getState.quizzes;
      var question = questions.get(questionId);
      if (loading[_this.responseSyncKey(quizId, questionId)]) return;
      var quiz = quizzes.get(quizId);
      var response = responses.getIn([quizId, questionId]);
      if (!response) {
        response = new _Response.default({
          relationships: {
            quiz: {
              data: {
                id: quizId
              }
            },
            question: {
              data: {
                id: questionId
              }
            }
          }
        });
      }
      var tutorMode = (quiz === null || quiz === void 0 ? void 0 : quiz.get('type')) === 'tutor';
      var ungraded = tutorMode && response.get('correct') !== null && response.get('correct') !== undefined;
      var inputAttribute = ungraded ? 'ungraded_user_input' : 'user_input';
      var evaluationAttribute = ungraded ? 'ungraded_correct' : 'correct';

      // Evaluating a Tutor Mode Response makes it "answered" in the scope of the Quiz
      var answeredBefore = response.get(inputAttribute) !== null || tutorMode && response.get('evaluated_at') !== null;
      var correctBefore = response.get(evaluationAttribute);
      var totalAnswered = quiz.get('answeredCount');
      var totalAnsweredCorrectly = quiz.get('correctCount');
      var totalAnsweredIncorrectly = quiz.get('incorrectCount');
      if (question.get('aact_type')) {
        response = response.set(inputAttribute, JSON.stringify(selectedAnswer));
      } else {
        switch (question.get('type')) {
          case 'HotspotQuestion':
            response = response.set(inputAttribute, "".concat(selectedAnswer, ",").concat(!!hotspotIsCorrect));
            break;
          case 'OpenEndedQuestion':
          case 'FillInBlankQuestion':
            {
              response = response.set(inputAttribute, selectedAnswer);
              break;
            }
          case 'SortableQuestion':
          case 'DragDropCloze':
          case 'MatrixDropdown':
          case 'DropdownTable':
            response = response.set(inputAttribute, JSON.stringify(selectedAnswer));
            break;
          case 'MultipleChoiceQuestion':
          case 'GraphicChoiceQuestion':
          default:
            {
              // Extract Answer IDs
              var answerIds = (0, _response.responseAnswerIds)(response, ungraded);
              var answerSelected = answerIds.indexOf(selectedAnswer) !== -1;
              if (question.get('answers').filter(function (answer) {
                return answer.get('is_correct');
              }).size > 1) {
                // Multiple-select update
                if (answerSelected) {
                  answerIds.splice(answerIds.indexOf(selectedAnswer), 1);
                } else {
                  answerIds.push(selectedAnswer);
                }
              } else if (answerSelected) {
                answerIds = '';
              } else {
                answerIds = [selectedAnswer];
              }
              response = response.set(inputAttribute, answerIds ? JSON.stringify(answerIds) : answerIds);
              break;
            }
        }
      }
      response = response.set(evaluationAttribute, null).set('synced', false).set('updated_at', (0, _dateTime.getServerTimeNow)());
      if (!ungraded) {
        // Evaluating a Tutor Mode Response makes it "answered" in the scope of the Quiz
        var answeredAfter = response.get(inputAttribute) !== null || tutorMode && response.get('evaluated_at') !== null;
        if (answeredBefore !== answeredAfter) totalAnswered += answeredAfter ? 1 : -1;
        if (correctBefore === true) totalAnsweredCorrectly -= 1;
        if (correctBefore === false) totalAnsweredIncorrectly -= 1;
        if (offline) {
          response = response.set('answered_at', (0, _dateTime.getServerTimeNow)());
        }
      }
      dispatch({
        type: _constants.RESPONSE_SET,
        payload: {
          quizId: quizId,
          questionId: questionId,
          response: response,
          totalAnswered: totalAnswered,
          totalAnsweredCorrectly: totalAnsweredCorrectly,
          totalAnsweredIncorrectly: totalAnsweredIncorrectly
        }
      });
    };
  };
  this.responseEvaluateLocal = function (quizId, questionId) {
    return function (dispatch, getState) {
      var _getState2 = getState(),
        questions = _getState2.questions,
        responses = _getState2.responses,
        quizzes = _getState2.quizzes,
        session = _getState2.session;
      var question = questions.get(questionId);
      var quiz = quizzes.get(quizId);
      var response = responses.getIn([quizId, questionId]);
      // No previous response case => Set the response and evaluate it right away calculating new counters
      if (!response) {
        // We need to handle the case where the user sees the explanation in a downloaded quiz without having selected any answer
        response = new _Response.default({
          relationships: {
            quiz: {
              data: {
                id: quizId
              }
            },
            question: {
              data: {
                id: questionId
              }
            },
            user: {
              data: {
                id: session.get('current_user_id')
              }
            }
          }
        });
        response = response.set('correct', false).set('user_input', null).set('synced', false).set('updated_at', (0, _dateTime.getServerTimeNow)()).set('evaluated_at', (0, _dateTime.getServerTimeNow)());
        dispatch({
          type: _constants.RESPONSE_SET,
          payload: {
            quizId: quizId,
            questionId: questionId,
            response: response
          }
        });
        var _totalAnswered = quiz.get('answeredCount') + 1;
        var _totalAnsweredCorrectly = quiz.get('correctCount');
        var _totalAnsweredIncorrectly = quiz.get('incorrectCount') + 1;
        var correct = false;
        var _payload = {
          quizId: quizId,
          questionId: questionId,
          totalAnswered: _totalAnswered,
          totalAnsweredCorrectly: _totalAnsweredCorrectly,
          totalAnsweredIncorrectly: _totalAnsweredIncorrectly,
          correct: correct,
          response: response
        };
        dispatch({
          type: _constants.RESPONSE_EVALUATE_LOCAL,
          payload: _payload
        });
        return;
      }
      // Previous response case => Evaluate the response and calculate new counters
      var tutorMode = (quiz === null || quiz === void 0 ? void 0 : quiz.get('type')) === 'tutor';
      var ungraded = tutorMode && response.get('correct') !== null;

      // Evaluating a Tutor Mode Response makes it "answered" in the scope of the Quiz
      var answeredBefore = response.get('user_input') !== null || tutorMode && response.get('evaluated_at') !== null;
      var correctBefore = response.get('correct');
      var totalAnswered = quiz.get('answeredCount');
      var totalAnsweredCorrectly = quiz.get('correctCount');
      var totalAnsweredIncorrectly = quiz.get('incorrectCount');

      // Evaluating a Tutor Mode Response makes it "answered" in the scope of the Quiz
      var answeredAfter = response.get('user_input') !== null || tutorMode;
      var correctAfter = (0, _response.responseEvaluation)(response, question, ungraded);
      if (answeredBefore !== answeredAfter) totalAnswered += answeredAfter ? 1 : -1;
      if (!ungraded && correctBefore !== correctAfter) {
        if (correctBefore === true) totalAnsweredCorrectly -= 1;
        if (correctBefore === false) totalAnsweredIncorrectly -= 1;
        if (correctAfter === true) totalAnsweredCorrectly += 1;
        if (correctAfter === false) totalAnsweredIncorrectly += 1;
      }
      var payload = {
        quizId: quizId,
        questionId: questionId,
        totalAnswered: totalAnswered,
        totalAnsweredCorrectly: totalAnsweredCorrectly,
        totalAnsweredIncorrectly: totalAnsweredIncorrectly,
        response: response
      };
      payload[ungraded ? 'ungraded_correct' : 'correct'] = correctAfter;
      dispatch({
        type: _constants.RESPONSE_EVALUATE_LOCAL,
        payload: payload
      });
    };
  };
  this.responseEvaluate = function (quizId, questionId) {
    return function (dispatch, getState) {
      var _getState3 = getState(),
        quizzes = _getState3.quizzes,
        loading = _getState3.loading,
        responses = _getState3.responses;
      var quiz = quizzes.get(quizId);
      var response = responses.getIn([quizId, questionId]);
      var key = _this.responseEvaluateKey(quizId, questionId);
      if (!quiz) return Promise.reject(new Error('Quiz not found'));
      if (loading.has(key)) return loading.get(key);
      var tutorMode = quiz.get('type') === 'tutor';
      var ungraded = tutorMode && ((response === null || response === void 0 ? void 0 : response.get('correct')) || null) !== null;

      // Evaluating a Tutor Mode Response makes it "answered" in the scope of the Quiz
      var answeredBefore = !!response && (response.get('user_input') !== null || tutorMode && response.get('evaluated_at') !== null);
      var correctBefore = response ? response.get('correct') : null;
      var totalAnswered = quiz.get('answeredCount');
      var totalAnsweredCorrectly = quiz.get('correctCount');
      var totalAnsweredIncorrectly = quiz.get('incorrectCount');
      var promise = _this.api.put("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/questions/").concat(questionId, "/evaluate")).then(function (apiResponse) {
        // Evaluating a Tutor Mode Response makes it "answered" in the scope of the Quiz
        var answeredAfter = apiResponse.data.attributes.user_input !== null || tutorMode;
        var correctAfter = apiResponse.data.attributes.correct;
        if (answeredBefore !== answeredAfter) totalAnswered += answeredAfter ? 1 : -1;
        if (!ungraded && correctBefore !== correctAfter) {
          if (correctBefore === true) totalAnsweredCorrectly -= 1;
          if (correctBefore === false) totalAnsweredIncorrectly -= 1;
          if (correctAfter === true) totalAnsweredCorrectly += 1;
          if (correctAfter === false) totalAnsweredIncorrectly += 1;
        }
        dispatch({
          type: _constants.RESPONSE_EVALUATED,
          payload: _objectSpread({
            key: key,
            quizId: quizId,
            questionId: questionId,
            totalAnswered: totalAnswered,
            totalAnsweredCorrectly: totalAnsweredCorrectly,
            totalAnsweredIncorrectly: totalAnsweredIncorrectly
          }, apiResponse)
        });
        return apiResponse;
      }).catch(function (error) {
        dispatch({
          type: _constants.RESPONSE_EVALUATION_ERROR,
          payload: {
            error: error,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.RESPONSE_EVALUATING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.responseSync = function (quizId, questionId, event, time) {
    var ignoreEvaluate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return function (dispatch, getState) {
      var key = _this.responseSyncKey(quizId, questionId);
      var _getState4 = getState(),
        quizzes = _getState4.quizzes,
        responses = _getState4.responses;
      var quiz = quizzes.get(quizId);
      if (!quiz) return Promise.reject(new Error('Quiz not found'));
      var response = responses.getIn([quizId, questionId]);
      if ((!response || response.get('synced')) && (!event || !time)) {
        return Promise.resolve('Nothing to sync');
      }
      var _getState5 = getState(),
        loading = _getState5.loading;
      // If question type is aact then allow multiple response set
      var isAact = response === null || response === void 0 ? void 0 : response.get('is_aact');
      if (loading.has(key) && !isAact) return loading.get(key);
      var requestBody = {};
      if (response && !response.get('synced')) {
        requestBody.response = {
          user_input: response.get('user_input'),
          ungraded_user_input: response.get('ungraded_user_input')
        };
      }
      if (event && time) {
        requestBody.time_slice = {
          event: event,
          time: time
        };
      }
      if (ignoreEvaluate) {
        requestBody.ignore_evaluation = true;
      }
      var promise = _this.api.put("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/questions/").concat(questionId, "/response"), requestBody).then(function (apiResponse) {
        dispatch({
          type: _constants.RESPONSE_SYNCED,
          payload: _objectSpread({
            key: key,
            quizId: quizId,
            questionId: questionId
          }, apiResponse)
        });
        return apiResponse;
      }).catch(function (error) {
        dispatch({
          type: _constants.RESPONSE_SYNC_ERROR,
          payload: {
            error: error,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.RESPONSE_SYNCING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.responseTimeSpentKey = function (quizId, questionId) {
    return "quizzes/".concat(quizId, "/responses/").concat(questionId, "/time_spent");
  };
  this.responseTimeSpent = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(quizId, questionId) {
      return _this.responseTimeSpentKey(quizId, questionId);
    },
    request: function request(getState, quizId, questionId, event, time) {
      var _getState6 = getState(),
        quizzes = _getState6.quizzes;
      var quiz = quizzes.get(quizId);
      if (!quiz) return Promise.reject(new Error('Quiz not found'));
      var requestBody = {};
      if (event && time) {
        requestBody.time_slice = {
          event: event,
          time: time
        };
      }
      return _this.api.put("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/questions/").concat(questionId, "/response/time_spent"), requestBody);
    },
    additionalPayload: function additionalPayload(quizId, questionId) {
      return {
        quizId: quizId,
        questionId: questionId
      };
    },
    loadingConstant: _constants.RESPONSE_TIME_UPDATING,
    loadedConstant: _constants.RESPONSE_TIME_UPDATED,
    errorConstant: _constants.RESPONSE_TIME_ERROR
  });
  this.responseSyncOffline = function (quizId, questionId, event, time) {
    return function (dispatch, getState) {
      var _getState7 = getState(),
        quizzes = _getState7.quizzes,
        responses = _getState7.responses;
      var quiz = quizzes.get(quizId);
      if (!quiz) return Promise.reject(new Error('Quiz not found'));
      var response = responses.getIn([quizId, questionId]);
      if ((!response || response.get('synced')) && (!event || !time)) {
        return Promise.resolve('Nothing to sync');
      }
      dispatch({
        type: _constants.RESPONSE_SYNC_OFFLINE,
        payload: {
          createdAt: Date.now(),
          quizId: quizId,
          questionId: questionId,
          event: event,
          time: time,
          response: response
        }
      });
    };
  };
  this.api = api;
});
var _default = exports.default = Responses;